import { createReducer, on } from '@ngrx/store';
import { addOpenedTask, deleteOpenedTask, setOpenedTasks, deleteAllOpenedTasks, getOpenedTask } from './opened-tasks.actions';
import { OpenedTaskInfo } from '@/app/api/OpenedTaskInfo';

export interface OpenedTasksState {
  openedTasks: OpenedTaskInfo[];
}

export const initialOpenedTasksState: OpenedTasksState = {
  openedTasks: []
};

export const reducer = createReducer<OpenedTasksState>(
  initialOpenedTasksState,
  on(deleteAllOpenedTasks, (state) => ({
    ...state,
    openedTasks: []
  })),
  on(addOpenedTask, (state, { payload }) => {
    const currentState = state.openedTasks;
    const index = currentState.filter((item) => {
      const openedTask: boolean = item.taskId === payload.task.taskId;
      const openedFE: boolean = item.id === payload.task.id;

      return openedTask && openedFE;
    }).length;

    if (index > 0) {
      return state;
    } else {
      const clonedTask = structuredClone(payload.task) as OpenedTaskInfo;
      if (clonedTask.taskDTO) {
        clonedTask.taskDTO.work = undefined;
      }
      return {
        ...state,
        openedTasks: [...currentState, clonedTask]
      };
    }
  }),
  on(getOpenedTask, (state) => state), // Returns self? Original was on(GET_OPENEDTASK, (state) => state)
  on(deleteOpenedTask, (state, { payload }) => ({
    ...state,
    openedTasks: state.openedTasks.filter((item) => {
      return item.taskId !== payload.task.taskId;
    })
  })),
  on(setOpenedTasks, (state, { payload }) => ({
    ...state,
    openedTasks: payload.tasks
  }))
);
